import React, { useState } from "react";
import { Table } from "antd";
import styles from "./EquipmentMgmt.module.css";
import { useNavigate } from "react-router-dom";
import {
  Dropdown,
  SubmitButton,
  TextComponent,
  Modal,
} from "../../../../components";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import { ReactComponent as ViewIcon } from "../../../../assets/images/view.svg";
import { ReactComponent as ArchiveIcon } from "../../../../assets/images/archive.svg";

import { ReactComponent as EditIcon } from "../../../../assets/images/editIcon.svg";

const EquipmentManagement = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [isModal, setIsModal] = useState(false);
  const [selectedActions, setSelectedActions] = useState({});
  const [staffList] = useState([
    {
      no: "1.",
      equipmentName: "Stand mixers",
      station: "Mixing",
      maintenanceDue: "Aug 31, 2025",
      action: "View",
    },
    {
      no: "2.",
      equipmentName: "Proofing cabinet",
      station: "Oven",
      maintenanceDue: "Aug 15, 2025",
      action: "Edit",
    },
    {
      no: "3.",
      equipmentName: "Microwave oven",
      station: "Oven",
      maintenanceDue: "Feb 15, 2025",
      action: "Archive",
    },
    {
      no: "4.",
      equipmentName: "Dough sheeter",
      station: "Mixing",
      maintenanceDue: "Nov 15, 2025",
      action: "Archive",
    },
    {
      no: "5.",
      equipmentName: "Fondant tools",
      station: "Oven",
      maintenanceDue: "Oct 15, 2025",
      action: "View",
    },
    {
      no: "6.",
      equipmentName: "Measuring cups & spoons",
      station: "Mixing",
      maintenanceDue: "Sep 15, 2025",
      action: "View",
    },
  ]);

  const columns = [
    {
      title: "No.",
      dataIndex: "no",
      key: "no",
      render: (text) => (
        <TextComponent className={styles.materialText} text={`${text}`} />
      ),
    },
    {
      title: "Equipment Name",
      dataIndex: "equipmentName",
      key: "equipmentName",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Machine Category",
      dataIndex: "station",
      key: "station",
      render: (text) => (
        <TextComponent className={styles.materialText} text={text} />
      ),
    },
    {
      title: "Maintenance Due",
      dataIndex: "maintenanceDue",
      key: "maintenanceDue",
      render: (text) => (
        <TextComponent className={styles.materialText} text={text} />
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <div className={styles.itemsButtonDiv}>
          <ViewIcon
            className={styles.itemsButton}
            onClick={() => navigate("/EquipmentDetails/view")}
          />

          <EditIcon
            className={styles.itemsButton}
            onClick={() => navigate("/EditEquipment")}
          />
          <ArchiveIcon
            className={styles.itemsButton}
            onClick={() => setIsModal(true)}
          />
        </div>
      ),
    },
  ];

  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Equipment Management"}
        onSearch={(e) => setSearchTerm(e.target.value)}
        onSubmit={() => navigate("/AddEquipment")}
        submitButtonText={"Add Equipment"}
        showFilterIcon={true}
        showSubmitButton={true}
        showSearch={true}
      />

      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={staffList}
          pagination={false}
          rowKey="no"
        />
      </div>

      <Modal
        open={isModal}
        onClickOkButton={() => {
          setIsModal(false);
        }}
        onCancel={() => setIsModal(false)}
        className={styles.modalCont}
        title={"Archive"}
        headingClass={styles.modalHeading}
        width={"400px"}
        buttonTitle={"OK"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        onBtnPress={() => setIsModal(false)}
      >
        <div>
          <TextComponent
            text="Equipment Archived Successfully"
            className={styles.CardText}
          />
        </div>
      </Modal>
    </div>
  );
};

export default EquipmentManagement;
